/* eslint-disable no-plusplus */
// ********************************************************* //
// * Reference: https://www.youtube.com/watch?v=riDzcEQbX6k  //
// ********************************************************* //

// Import styles into JS
import 'normalize.css';
import '../styles/index.scss';

// Import Material Design Components modules
import { MDCRipple } from '@material/ripple';
import { MDCDialog } from '@material/dialog';
import { MDCCircularProgress } from '@material/circular-progress';
import soldierYelling from '../img/meme_templates/soldierYelling.jpg';
// Import your questions from file
import questions from './questions.js';

const dialog = new MDCDialog(document.querySelector('.mdc-dialog'));
const startButton = new MDCRipple(document.querySelector('#start-btn'));
const nextButton = new MDCRipple(document.querySelector('#next-btn'));
const questionContainerElement = document.querySelector('#question-container');
const questionElement = document.querySelector('#question');
const answerButtonsElement = document.querySelector('#answer-buttons');
const incorrectAnswers = [];

const circularProgress = new MDCCircularProgress(document.querySelector('.mdc-circular-progress'));
const circularProgressParent = document.querySelector('.mdc-circular-progress');
const circularProgressQuestions = document.querySelector('.questionProgress');
const gameContainer = document.querySelector('.container');
const numberOfQuestionsForm = document.querySelector('form');

circularProgress.open();
circularProgress.foundation.setProgress(0);

// Since we do not want our questions to always show up in the exact same order we need to shuffle them in a random order
let shuffledQuestions;
let currentQuestionIndex;
let score;
let startTime;
let endTime;

function startTimer() {
  startTime = new Date();
}

function endTimer() {
  endTime = new Date();
  let timeDiff = endTime - startTime; // in ms
  // strip the ms
  timeDiff /= 1000;

  // get seconds
  const seconds = Math.round(timeDiff);

  const elapsedTime = new Date(seconds * 1000).toISOString().substr(11, 8);
  const hh = Math.round(elapsedTime.split(':')[0]);
  const mm = Math.round(elapsedTime.split(':')[1]);
  const ss = Math.round(elapsedTime.split(':')[2]);

  if (elapsedTime.split(':')[0] !== '00') {
    return `Quiz completed in ${hh === 1 ? '1 hour ' : `${hh} hours `} ${mm === 1 ? '1 minute' : `${mm} minutes`} and ${ss === 1 ? '1 second' : `${ss} seconds`}`;
  }
  if (elapsedTime.split(':')[1] !== '00') {
    return `Quiz completed in ${mm === 1 ? '1 minute' : `${mm} minutes`} and ${ss === '1' ? '1 second' : `${ss} seconds`}`;
  }
  return `Quiz completed in ${ss === 1 ? '1 second' : `${ss} seconds`}`;
}

// ! Remove on Production
// window.incorrectAnswers = incorrectAnswers;
// window.answerButtonsElement = answerButtonsElement;
// window.dialog = dialog;
// window.questions = questions;

// Center the progress inside the circular progress indicator
function getCenterOfProgressCircle(parent, child) {
  let buffer = 8;
  if (currentQuestionIndex < 9) {
    buffer = 8;
  } else {
    buffer = 21;
  }

  const newStyle = {
    position: 'absolute',
    top: `${(parent.offsetHeight - child.offsetHeight) / 2 + parent.scrollTop}px`,
    left: `${(parent.offsetWidth - child.offsetHeight) / 2 + parent.scrollLeft - buffer}px`,
  };

  child.setAttribute('style', `position: ${newStyle.position}; top: ${newStyle.top}; left: ${newStyle.left};`);

  // Resize the font on the progress counter if its at 100 or larger
  if (currentQuestionIndex >= 99) {
    circularProgressQuestions.style.fontSize = '1.2rem';
    circularProgressQuestions.style.left = newStyle.left - 5;
  }
}

// https://stackoverflow.com/questions/19269545/how-to-get-a-number-of-random-elements-from-an-array
function getRandom(arr, n) {
  // Create an empty array with a length of n
  const result = new Array(n);
  let len = arr.length;
  const taken = new Array(len);
  if (n > len) throw new RangeError('getRandom: more elements taken than available');
  // eslint-disable-next-line no-param-reassign
  while (n--) {
    const x = Math.floor(Math.random() * len);
    result[n] = arr[x in taken ? taken[x] : x];
    taken[x] = --len in taken ? taken[len] : len;
  }
  return result;
}

// Automatically adjust the welcome image for mobile devices
const welcomeDiv = document.querySelector('.welcome');
const welcomeDivImg = welcomeDiv.querySelector('img');
const mq = window.matchMedia('(max-width: 812px)');
if (mq.matches) {
  welcomeDiv.querySelector('.quizHeadline').style.fontSize = '1.5rem';
  welcomeDivImg.setAttribute('width', '100%');
  welcomeDivImg.setAttribute('style', 'margin: 0 auto; text-align: center');
}

function clearStatusClass(element) {
  element.classList.remove('correct');
  element.classList.remove('wrong');
}

// Reset everything related to our forms, our body, our questions all back to their default state every time we set a new question
function resetState() {
  clearStatusClass(document.body);
  // Hide the next button when a new question is prompted
  nextButton.root_.classList.add('hide');
  // Loop through all the children for our answer button elements. If there is a child inside our answer button elements then we want to remove it
  while (answerButtonsElement.firstChild) {
    answerButtonsElement.removeChild(answerButtonsElement.firstChild);
  }
}

function setStatusClass(element, correct) {
  clearStatusClass(element);
  // Disable the buttons so the user can't keep clicking them and change the score
  element.setAttribute('disabled', true);
  dialog.open();
  if (correct) {
    element.classList.add('correct');
  } else {
    element.classList.add('wrong');
  }
}

async function populateDialog(button, question) {
  // Remove any data containers in the dialog before we start
  dialog.root.querySelectorAll('.dialogDataContainer').forEach((element) => element.remove());

  const dialogDataContainer = document.createElement('div');
  dialogDataContainer.classList.add('dialogDataContainer');

  // Insert the Symbol Name into the Dialog
  Object.entries(button).forEach((child) => {
    if (child[1].classList.contains('correct')) {
      const { textContent } = child[1];
      const titleDiv = document.createElement('div');
      titleDiv.classList.add('titleDiv');
      titleDiv.classList.add('mdc-typography--headline5');
      titleDiv.innerText = textContent;
      dialogDataContainer.appendChild(titleDiv);
    }
  });

  // Insert the symbol Description into the Dialog
  const descDiv = document.createElement('div');
  descDiv.classList.add('mdc-typography--body1');
  descDiv.innerHTML = `<strong><u>Description:</u></strong> ${question.description}`;
  dialogDataContainer.appendChild(descDiv);
  // Insert the Symbol SVG into the Dialog
  const svgDiv = document.createElement('div');
  svgDiv.innerHTML = question.symbolSVG;
  dialogDataContainer.appendChild(svgDiv);
  // Append all the answer data to the dialog
  await dialog.content_.insertAdjacentElement('afterend', dialogDataContainer);
  // Readjust the SVG viewBox once it has been added to the DOM
  const questionSymbol = svgDiv.querySelector('svg');
  const { x, y, width, height } = questionSymbol.getBBox();
  questionSymbol.setAttributeNS(null, 'viewBox', `${x} ${y} ${width} ${height}`);
}

// Do something when a user selects an answer
async function selectAnswer(e) {
  // Get whichever button the user selected
  const selectedButton = await e.target;
  const { correct } = selectedButton.dataset;
  // Changes the colors of the document body if correct
  setStatusClass(document.body, correct);
  // Loop through all you other buttons and set a class for them
  Array.from(answerButtonsElement.children).forEach((button) => {
    setStatusClass(button, button.dataset.correct);
  });

  if (correct) {
    score += 1;
    dialog.root.querySelector('.mdc-dialog__surface').classList.add('correct');
    dialog.content_.innerText = 'Correct';
    selectedButton.insertAdjacentHTML('beforeend', `<div class="checkmark-correct"></div>`);
  } else {
    dialog.root.querySelector('.mdc-dialog__surface').classList.add('wrong');
    dialog.content_.innerText = 'Incorrect';
    selectedButton.insertAdjacentHTML('beforeend', `<div class="checkmark-wrong"></div>`);
    // If the user got a question wrong, push it to an array so he can review it on the results screen
    shuffledQuestions[currentQuestionIndex].answers.forEach((answer) => {
      if (answer.correct) {
        incorrectAnswers.push({
          text: answer.text,
          svg: shuffledQuestions[currentQuestionIndex].symbolSVG,
        });
      }
    });
  }

  // Bring up a MDC Dialog with the correct answer and explanation
  populateDialog(answerButtonsElement.children, shuffledQuestions[currentQuestionIndex]);

  if (shuffledQuestions.length > currentQuestionIndex + 1) {
    nextButton.root_.classList.remove('hide');
  } else {
    startButton.root_.innerText = 'Restart';
    startButton.root_.classList.remove('hide');
    questionContainerElement.classList.add('hide');
    document.querySelector('.results').classList.remove('hide');
    // This is the results screen
    let scoreMessage = '';
    if (score / shuffledQuestions.length >= 1) {
      scoreMessage = `<div class="mdc-typography--headline4" style="color:green">PERFECT SCORE!!!</div><br/>`;
    } else {
      scoreMessage = '<div class="mdc-typography--headline4" style="color:red">These are the questions you got wrong</div>';
    }
    // Turn on the special styles for the final results container
    if (!gameContainer.classList.contains('finalResultsContainer')) {
      gameContainer.classList.add('finalResultsContainer');
    }

    // Change the og:title to reflect the users score
    document
      .querySelector('meta[property="og:title"]')
      .setAttribute('content', `I just scored ${Math.round(((score / shuffledQuestions.length) * 100 + Number.EPSILON) * 100) / 100}% on this military symbols quiz!`);
    // Change the twitter:description to reflect the users score
    document
      .querySelector('meta[name="twitter:description"]')
      .setAttribute('content', `I just scored ${Math.round(((score / shuffledQuestions.length) * 100 + Number.EPSILON) * 100) / 100}% on this military symbols quiz!`);

    // the "/*html*/" prefix comment is for the es6-string-html VS Code Extension
    document.querySelector('.results').innerHTML = /*html*/`
    <div class="mdc-layout-grid__inner">
      <div class="mdc-layout-grid__cell--span-12 resultsText">
        <div class="mdc-typography--headline2">Your final score was
          ${Math.round(((score / shuffledQuestions.length) * 100 + Number.EPSILON) * 100) / 100}%
          </div>
          <div class="mdc-typography--headline5">
          ${endTimer()}
        </div>
        <hr/>
        <canvas class="meme-canvas"></canvas>
      </div>
      <div class="mdc-layout-grid__cell--span-12 mdc-layout-grid__cell--span-12-phone resultsText">${scoreMessage}</div>
      <div class="mdc-layout-grid__cell--span-12 mdc-layout-grid__cell--span-12-phone resultsImg"></div>
      <div class="mdc-layout-grid__cell--span-12 mdc-layout-grid__cell--span-12-phone"><hr/></div>
      <div class="mdc-layout-grid__cell--span-12 mdc-layout-grid__cell--span-12-phone resultsButtons">
        <div class="mdc-layout-grid__inner">
          <div class="mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-12-phone">
            <button class="btn shareResultsToFacebook" style="display:flex;align-items:center;padding: 4px;background-color: dodgerblue;padding-right: 10px;" onclick="shareToFacebook()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="67.5 67.5 365 365" width="48" height="48">
                <defs/>
                <path fill="#1877f2" d="M432.5 250a182.5 182.5 0 10-211 180.3V302.8h-46.3V250h46.3v-40.2c0-45.7 27.2-71 68.9-71 20 0 40.9 3.6 40.9 3.6v44.9h-23c-22.7 0-29.7 14.1-29.7 28.5V250h50.6l-8.1 52.8h-42.5v127.5A182.5 182.5 0 00432.5 250z"/>
                <path fill="#fff" d="M321 302.8l8.1-52.8h-50.6v-34.2c0-14.4 7.1-28.5 29.7-28.5h23v-44.9s-20.9-3.6-40.9-3.6c-41.7 0-68.9 25.3-68.9 71V250h-46.3v52.8h46.3v127.5a178.7 178.7 0 0057 0V302.8H321z"/>
              </svg>
            Share Results</button>
          </div>
          <div class="mdc-layout-grid__cell--span-6 mdc-layout-grid__cell--span-12-phone">
            <button class="btn shareResultsToTwitter" style="display:flex;align-items:center;padding: 4px;background-color: dodgerblue;padding-right: 10px;" onclick="shareToTwitter()">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="3.7 5.1 49.2 49.2" width="48" height="48">
                <path d="M28.348 5.157c-13.6 0-24.625 11.027-24.625 24.625 0 13.6 11.025 24.623 24.625 24.623s24.623-11.023 24.623-24.623c0-13.598-11.024-24.625-24.623-24.625zm12.404 19.66c.013.266.018.533.018.803 0 8.201-6.242 17.656-17.656 17.656a17.572 17.572 0 01-9.513-2.787c.486.057.979.086 1.48.086a12.45 12.45 0 007.707-2.656 6.214 6.214 0 01-5.796-4.311 6.06 6.06 0 001.167.111c.566 0 1.114-.074 1.635-.217a6.21 6.21 0 01-4.979-6.084l.001-.08a6.184 6.184 0 002.811.777 6.204 6.204 0 01-2.761-5.166c0-1.137.306-2.204.84-3.12a17.618 17.618 0 0012.792 6.483 6.206 6.206 0 016.045-7.619 6.2 6.2 0 014.529 1.959 12.395 12.395 0 003.941-1.506 6.223 6.223 0 01-2.73 3.433 12.407 12.407 0 003.565-.977 12.537 12.537 0 01-3.096 3.215z" fill="#fff"/>
              </svg>
              Share Results
            </button>
          </div>
          <div class="mdc-layout-grid__cell--span-12 mdc-layout-grid__cell--span-12-phone">
            <button class="btn" style="text-align: center; margin: 0 auto; margin-bottom: 1rem; background-color: green;" onclick="openApp()">Try MGRS Mapper</button>
          </div>
        </div>
      </div>
    </div>`;
    // Insert the symbols the user got wrong in the results screen
    incorrectAnswers.forEach(async (incorrect) => {
      const resultsImg = document.querySelector('.resultsImg');
      const resDiv = document.createElement('div');
      resDiv.innerHTML += incorrect.svg;
      resultsImg.appendChild(resDiv);
      resDiv.firstChild.setAttribute('height', '100');
      resDiv.firstChild.setAttribute('width', '100');
      resDiv.insertAdjacentHTML('beforeend', `<p class="mdc-typography--body1" style="text-align:center;">${incorrect.text}</p>`);
    });

    // If there are less than 4 incorrect answers, center them in the results page, otherwise it looks like shit
    if (incorrectAnswers.length < 4) {
      if (mq.matches) {
        return document.querySelector('.resultsImg').style.justifyContent = 'space-between';
      }
      document.querySelector('.resultsImg').style.justifyContent = 'center';
    } else {
      document.querySelector('.resultsImg').style.justifyContent = 'space-between';
    }

    // This was the old way I used to add a meme. However the time to return the image took too long
    // meme generator API: https://api.memegen.link/
    // <img src="https://api.memegen.link/images/custom/HOLY_SHIT/YOU_GOT_${score}~s${shuffledQuestions.length}_CORRECT.png?background=https://i.imgur.com/YEGzive.jpg?1" height=${gameContainer.getBoundingClientRect().width / 2} loading="eager" style="background:red;"/>

    // Generate a meme of your results
    const canvas = document.querySelector('.meme-canvas');
    const ctx = canvas.getContext('2d');

    const generateCanvasMeme = () => {
      if (!document.querySelector('.meme-canvas')) {
        return;
      }

      const img = new window.Image();
      img.crossOrigin = 'Anonymous';
      img.onload = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        img.width = img.naturalWidth;
        img.height = img.naturalHeight;
        // Set scale to fit image to canvas,
        const scale = Math.min(canvas.width / img.width, canvas.height / img.height);

        // Set new image dimensions.
        const scaledWidth = img.width * scale;
        const scaledHeight = img.height * scale;
        ctx.drawImage(img, (canvas.width - scaledWidth) / 2, (canvas.height - scaledHeight) / 2, scaledWidth, scaledHeight);

        ctx.lineWidth = 5;
        ctx.strokeStyle = 'black';
        ctx.fillStyle = 'white';
        ctx.textAlign = 'center';
        ctx.lineJoin = 'round';
        const memeFont = `bold 3rem Roboto`;
        ctx.font = memeFont;

        const topText = String('holy shit').toUpperCase();
        const botText = String(`You Got ${score}/${shuffledQuestions.length} Correct`).toUpperCase();

        const textX = canvas.width / 2;
        const topY = canvas.height - (canvas.height / 30) * 24;
        const botY = canvas.height - (canvas.height / 30) * 6;

        ctx.textBaseline = 'top';
        ctx.strokeText(topText, textX, topY);
        ctx.fillText(topText, textX, topY);

        ctx.textBaseline = 'bottom';
        ctx.strokeText(botText, textX, botY);
        ctx.fillText(botText, textX, botY);
      };

      img.src = soldierYelling;

      // Trim the whitespace on the canvas element
      // https://stackoverflow.com/questions/11796554/automatically-crop-html5-canvas-to-contents
      setTimeout(() => {
        const topLeft = {
          x: canvas.width,
          y: canvas.height,
          update(x, y) {
            this.x = Math.min(this.x, x);
            this.y = Math.min(this.y, y);
          },
        };

        const bottomRight = {
          x: 0,
          y: 0,
          update(x, y) {
            this.x = Math.max(this.x, x);
            this.y = Math.max(this.y, y);
          },
        };

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);

        for (let x = 0; x < canvas.width; x++) {
          for (let y = 0; y < canvas.height; y++) {
            const alpha = imageData.data[y * (canvas.width * 4) + x * 4 + 3];
            if (alpha !== 0) {
              topLeft.update(x, y);
              bottomRight.update(x, y);
            }
          }
        }

        const width = bottomRight.x - topLeft.x;
        const height = bottomRight.y - topLeft.y;

        const croppedCanvas = ctx.getImageData(topLeft.x, topLeft.y, width, height);
        canvas.width = width;
        canvas.height = height;
        ctx.putImageData(croppedCanvas, 0, 0);
      }, 20);
    };

    const initCanvas = () => {
      if (!document.querySelector('.meme-canvas')) {
        return;
      }
      if (mq.matches) {
        canvas.width = gameContainer.getBoundingClientRect().width - 16;
        canvas.height = gameContainer.getBoundingClientRect().height - 16;
      } else {
        canvas.width = gameContainer.getBoundingClientRect().width / 2;
        canvas.height = gameContainer.getBoundingClientRect().height / 2;
      }

      generateCanvasMeme();
    };

    // Wait for the scale animation to run and then add the canvas
    setTimeout(() => {
      initCanvas();
    }, 300);

    setTimeout(() => {
      if (mq.matches) {
        const { height } = gameContainer.querySelector('.results').getBoundingClientRect();
        const { innerHeight } = window;
        gameContainer.style.height = `${height + 100}px`;
        gameContainer.style.top = `${innerHeight + 16}px`;
      }
    }, 400);
  }
}

async function showQuestion(question) {
  const clientHeightArray = [];
  dialog.root.querySelector('.mdc-dialog__surface').classList.remove('wrong');
  dialog.root.querySelector('.mdc-dialog__surface').classList.remove('correct');
  // Set the text of the question from the current index of the shuffled array of questions
  questionElement.innerHTML = `<p class="mdc-typography--headline3">${question.question}</p>`;
  // Add the SVG symbol to the question
  questionElement.insertAdjacentHTML('beforeend', question.symbolSVG);
  // Readjust the SVG viewBox once it has been added to the DOM
  const questionSymbol = questionElement.querySelector('svg');
  const { x, y, width, height } = questionSymbol.getBBox();
  questionSymbol.setAttributeNS(null, 'viewBox', `${x} ${y} ${width} ${height}`);
  // Update the users progress of questions answered
  circularProgress.foundation.setProgress((currentQuestionIndex + 1) / shuffledQuestions.length);
  circularProgressQuestions.innerText = `${currentQuestionIndex + 1}/${shuffledQuestions.length}`;
  // Populate the different answers from the current index of the shuffled array of questions
  await question.answers.forEach((answer) => {
    // Create a button for each possible answer
    const button = document.createElement('button');
    button.innerText = answer.text;
    button.classList.add('btn');
    // If the answer is correct then add a data attribute to it
    if (answer.correct) {
      button.dataset.correct = answer.correct;
    } else {
      // IOT obfuscate the correct answer I am adding a 'fake' attribute with the word correct spelled with a Ukrainian 'o'
      // If a sneaky bastard looks in the source code they will look like duplicate values
      button.setAttribute('data-cоrrect', 'true');
    }
    // Add the buttons to the container
    answerButtonsElement.appendChild(button);
    // Store the client heights of all the buttons so I can find the largest one
    clientHeightArray.push(button.clientHeight);
    // Set an event listener on each button
    button.addEventListener('click', selectAnswer);
  });
  // Loop through the array of button heights and set them all to the largest one
  answerButtonsElement.childNodes.forEach((node) => {
    node.setAttribute('style', `height: ${Math.max(...clientHeightArray)}px`);
  });
  // Update the circular progress indicator
  getCenterOfProgressCircle(circularProgressParent, circularProgressQuestions);
}

// When a user clicks the Next button inside our app
function setNextQuestion() {
  resetState();
  // pass in our shuffled questions at the current index
  showQuestion(shuffledQuestions[currentQuestionIndex]);
  // Make sure the symbol is viewable to the user when they click next
  questionElement.scrollIntoView();
}

// ********************************************************* //
// * Start the game                                          //
// ********************************************************* //
function startGame() {
  let numQuestions;
  if (mq.matches) {
    gameContainer.style.height = '100%';
  }
  document.querySelector('.mdc-circular-progress').style.display = 'block';
  // Verify the number of questions the user is choosing on start
  numberOfQuestionsForm.querySelectorAll('input').forEach((num) => {
    if (num.checked) {
      console.log(`The user has chosen to try for ${num.value} questions`);
      numQuestions = num.value;
    }
  });
  // If the user RESTARTS a game, remove the final results container styles and close the Dialog again
  if (gameContainer.classList.contains('finalResultsContainer')) {
    gameContainer.classList.remove('finalResultsContainer');
    dialog.close();
  }
  // Hide the Start button when the game is initialized
  startButton.root_.classList.add('hide');
  // Remove all incorrect answers from the array on start
  incorrectAnswers.length = 0;
  document.querySelector('.results').classList.add('hide');
  // Hide the welcome screen when the game is initialized
  document.querySelector('.welcome').classList.add('hide');
  // Set the shuffled questions equal to the shuffled array
  // The sort method will sort the array based on if the index is a negative or positive number
  // So we need to get a random number that is either below zero or above zero
  // Math.random() will give you a number between 0 and 1
  // If we subtract 0.5 from Math.random() this will return a number that is either below zero or above it
  // https://flaviocopes.com/how-to-shuffle-array-javascript/
  shuffledQuestions = questions.sort(() => Math.random() - 0.5);
  // Shuffle the questions and return an array of whatever the number of questions the user chose
  shuffledQuestions = getRandom(shuffledQuestions, numQuestions);
  // Set the index to 0 when the game is initialized because we are starting on the first question in our shuffled array
  currentQuestionIndex = 0;
  score = 0;
  // When the page loads the questions are hidden, therefore remove the hide class when the game is initialized
  questionContainerElement.classList.remove('hide');
  // Set the first question for the user when the game is initialized
  setNextQuestion();
  // Start the timer
  startTimer();
}

// ********************************************************* //
// * Select the number of questions                          //
// ********************************************************* //
function checkBoxLogic(event) {
  const formElement = event.target.offsetParent;

  // Uncheck all options at first
  for (let index = 0; index < formElement.length; index++) {
    const element3 = formElement[index];
    element3.toggleAttribute('checked', false);
  }

  // Now find out what the target option was and set it to checked
  formElement.querySelectorAll('label').forEach((element) => {
    const label = element;
    if (label.getAttribute('for').match(event.target.id)) {
      label.style.color = 'green';
      event.target.toggleAttribute('checked', true);
    } else {
      label.style.color = 'black';
    }
  });
}

// ********************************************************* //
// * Event Listeners                                         //
// ********************************************************* //
// Start the game when a user clicks the Start button
startButton.listen('click', startGame);
numberOfQuestionsForm.addEventListener('change', checkBoxLogic);
nextButton.listen('click', () => {
  currentQuestionIndex += 1;
  setNextQuestion();
});

// ********************************************************* //
// * Social Sharing                                          //
// ********************************************************* //
const quizUrl = `https://mgrs-mapper.com${window.location.pathname}`;

window.shareToTwitter = () => {
  const href = `https://twitter.com/intent/tweet/?text=${encodeURIComponent(document.querySelector('meta[name="twitter:description"]').content)}&url=${encodeURIComponent(quizUrl)}&via=MGRSMapper`;
  window.open(href, 'Twitter', 'toolbar=no,location=0,status=no,menubar=no,scrollbars=yes,width=626,height=436,resizable=1');
};

window.shareToFacebook = () => {
  window.open(`https://www.facebook.com/sharer/sharer.php?u=${quizUrl}`, 'sharer', 'width=626,height=436');
};

window.openApp = () => {
  if (process.env.NODE_ENV === 'development') {
    window.open('http://localhost:3000/app');
  }
  window.open('https://mgrs-mapper.com/app');
};
